export default __webpack_public_path__ + "static/media/white-up-arrow.2e140c27.svg";